import { DEFAULT_SHELF_HEIGHT } from 'lib/modelBuilder/constants';

export function getBestCommonShelfValue(valueArray: number[]): number {
  /**
   * Select the value the most appropriate as common value for shelf height
   */
  if (valueArray.length === 0) return DEFAULT_SHELF_HEIGHT;
  const counts: any = {};
  let max = valueArray[0];
  for (let val of valueArray) {
    counts[val] = counts[val] ? counts[val] + 1 : 1;
    if (counts[val] > counts[max]) max = val;
  }

  if (counts[max] === 1) return Math.max(...valueArray);
  return max;
}
